import { useAtom } from 'jotai';
import { useCallback } from 'react';

import type { PaymentWalletsAtom } from '$src/business/atoms/payment-wallets';

import { selectedPaymentMethodAtom } from '$src/business/atoms/payment-method';
import { ZPaymentWalletsSchema, paymentWalletsAtom } from '$src/business/atoms/payment-wallets';

export function usePaymentMethodsAtom() {
  const [paymentWallets, setPaymentWallets] = useAtom(paymentWalletsAtom);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useAtom(selectedPaymentMethodAtom);

  const onPaymentWalletsChange = useCallback(
    (status: PaymentWalletsAtom) => {
      const safeMessage = ZPaymentWalletsSchema.safeParse(status);
      if (safeMessage.success) {
        setPaymentWallets(safeMessage.data);
      } else {
        console.error('Error while parsing payment wallets change', {
          error: safeMessage.error,
          hook: usePaymentMethodsAtom.name,
        });
      }
    },
    [setPaymentWallets],
  );

  const changeWallets = useCallback(
    (wallets: string[]) => {
      onPaymentWalletsChange({
        wallets,
      });
    },
    [onPaymentWalletsChange],
  );

  const changeSelectedPaymentMethod = useCallback(
    (method: string) => {
      setSelectedPaymentMethod({
        type: method,
      });
    },
    [setSelectedPaymentMethod],
  );

  return { paymentWallets, changeWallets, changeSelectedPaymentMethod, selectedPaymentMethod };
}
